import React from 'react';
import '@/App.css';
import { Navbar } from '@/components/landing/Navbar';
import { Hero } from '@/components/landing/Hero';
import { Problem } from '@/components/landing/Problem';
import { Solution } from '@/components/landing/Solution';
import { Benefits } from '@/components/landing/Benefits';
import { ProductDemo } from '@/components/landing/ProductDemo';
import { Pricing } from '@/components/landing/Pricing';
import { FAQ } from '@/components/landing/FAQ';
import { FinalCTA } from '@/components/landing/FinalCTA';
import { Footer } from '@/components/landing/Footer';

function App() {
  return (
    <div className="App min-h-screen bg-background text-foreground smooth-scroll">
      <Navbar />
      <main>
        <Hero />
        <Problem />
        <Solution />
        <div id="benefits">
          <Benefits />
        </div>
        <ProductDemo />
        <div id="pricing">
          <Pricing />
        </div>
        <div id="faq">
          <FAQ />
        </div>
        <FinalCTA />
      </main>
      <Footer />
    </div>
  );
}

export default App;
